export default __webpack_public_path__ + "static/media/cross.de8264d9.svg";